import { get } from 'lodash';

import { features } from '@zapier/design-system-revenue/src/utils';
import { Feature, PlanV2 } from '@zapier/design-system-revenue/src/types';

/**
 * Lists the features lost from change from `fromPlan` to `toPlan`
 */
export const getFeaturesLost = (
  fromPlan?: PlanV2,
  toPlan?: PlanV2
): Feature[] => {
  if (!fromPlan || !toPlan) {
    return [];
  }
  return features.filter(
    feature => get(fromPlan, feature.key) && !get(toPlan, feature.key)
  );
};
